var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21444 12.0604C4.10377 11.8909 4.04843 11.8062 4.01745 11.6755C3.99418 11.5774 3.99418 11.4226 4.01745 11.3245C4.04843 11.1938 4.10377 11.1091 4.21444 10.9396C5.12902 9.53952 7.85134 6 12 6C16.1487 6 18.871 9.53952 19.7856 10.9396C19.8962 11.1091 19.9516 11.1938 19.9825 11.3245C20.0058 11.4226 20.0058 11.5774 19.9825 11.6755C19.9516 11.8062 19.8962 11.8909 19.7856 12.0604C18.871 13.4605 16.1487 17 12 17C7.85134 17 5.12902 13.4605 4.21444 12.0604Z",
    stroke: "#979DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8571C13.3465 13.8571 14.438 12.8018 14.438 11.5C14.438 10.1982 13.3465 9.14286 12 9.14286C10.6535 9.14286 9.56201 10.1982 9.56201 11.5C9.56201 12.8018 10.6535 13.8571 12 13.8571Z",
    stroke: "#979DAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.426cca6ee73e3baad54162d0eddbe522.svg";
export { ForwardRef as ReactComponent };